"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var draggable_1 = require("./draggable");
exports.Draggable = draggable_1.Draggable;
//# sourceMappingURL=index.js.map


//////////////////
// WEBPACK FOOTER
// ./~/draggable-vue-directive/dist/index.js
// module id = 4
// module chunks = 0